import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  const floatingCards = [
    { icon: 'ri-star-fill', text: '+5 完成跑步', color: 'from-amber-400 to-orange-400', delay: '0s' },
    { icon: 'ri-trophy-fill', text: '习惯达人', color: 'from-purple-400 to-pink-400', delay: '1.5s' },
    { icon: 'ri-heart-fill', text: '兑换电影票', color: 'from-green-400 to-teal-400', delay: '0.8s' },
    { icon: 'ri-brain-fill', text: '学习专注 92%', color: 'from-blue-400 to-cyan-400', delay: '2s' }
  ];

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#0a1a4a] via-[#0d2d6e] to-[#1a56db]"></div>
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-indigo-600/20 rounded-full blur-3xl animate-pulse" style={{animationDelay:'1s'}}></div>
      </div>
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="absolute w-1 h-1 bg-white/30 rounded-full animate-pulse" style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 3}s`,
            animationDuration: `${2 + Math.random() * 3}s`
          }}></div>
        ))}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 w-full pt-24 pb-16">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white/90 text-sm px-4 py-2 rounded-full mb-6 border border-white/20">
              <i className="ri-sparkling-fill text-amber-300"></i>
              <span>全新AI智能助手上线 · 语音记录积分更便捷</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6">
              让好习惯<br />
              成为家庭的<br />
              <span className="bg-gradient-to-r from-amber-300 via-orange-300 to-pink-300 bg-clip-text text-transparent">超能力</span>
            </h1>
            <p className="text-white/70 text-lg mb-8 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              通过科学的积分奖惩机制，帮助父母轻松培养孩子六大核心习惯，让成长变得有趣又有据可查。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button onClick={() => navigate('/dashboard')} className="whitespace-nowrap bg-gradient-to-r from-amber-400 to-orange-400 text-white font-bold px-8 py-4 rounded-2xl hover:shadow-2xl hover:scale-105 transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer">
                <span>免费开始使用</span>
                <i className="ri-arrow-right-line"></i>
              </button>
              <button className="whitespace-nowrap bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-2xl hover:bg-white/20 transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer">
                <i className="ri-play-circle-line text-lg"></i>
                <span>观看演示</span>
              </button>
            </div>
            <div className="flex flex-wrap gap-6 justify-center lg:justify-start mt-10">
              {[
                { num: '10,000+', label: '活跃家庭' },
                { num: '50万+', label: '好习惯记录' },
                { num: '95%', label: '家长满意度' }
              ].map(stat => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl font-black text-white">{stat.num}</div>
                  <div className="text-white/50 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 relative flex items-center justify-center">
            <div className="relative w-72 h-72 md:w-96 md:h-96">
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-400/30 to-purple-600/30 backdrop-blur-sm border border-white/20 animate-spin" style={{animationDuration:'20s'}}></div>
              <div className="absolute inset-8 rounded-full bg-gradient-to-br from-blue-500/40 to-indigo-700/40 backdrop-blur-sm border border-white/20 animate-spin" style={{animationDuration:'15s', animationDirection:'reverse'}}></div>
              <div className="absolute inset-16 rounded-full bg-gradient-to-br from-[#1a56db] to-[#0d2d6e] border-4 border-white/30 shadow-2xl flex items-center justify-center">
                <img src="https://public.readdy.ai/ai/img_res/329b747f-c748-48a9-a4d0-2bc2d9affcc1.png" alt="习惯星球" className="w-24 h-24 md:w-32 md:h-32 object-contain" />
              </div>
              {floatingCards.map((card, index) => {
                const positions = [
                  'top-0 -left-16 md:-left-24',
                  'top-0 -right-16 md:-right-20',
                  '-bottom-4 -left-12 md:-left-20',
                  '-bottom-4 -right-12 md:-right-16'
                ];
                return (
                  <div key={index} className={`absolute ${positions[index]} bg-white/15 backdrop-blur-md border border-white/30 rounded-2xl px-3 py-2 flex items-center gap-2 animate-bounce`} style={{animationDelay: card.delay, animationDuration:'3s'}}>
                    <div className={`w-7 h-7 flex items-center justify-center rounded-lg bg-gradient-to-r ${card.color}`}>
                      <i className={`${card.icon} text-white text-sm`}></i>
                    </div>
                    <span className="text-white text-xs font-medium whitespace-nowrap">{card.text}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}
